module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_5010.ba85b02a.png";